import styled, { css } from 'styled-components';

import type { IKakarikoTextStyleProps } from './types';

export const StyledKakarikoText = styled.div<IKakarikoTextStyleProps>`
  ${(props: IKakarikoTextStyleProps & { theme: any }) => {
    const { theme, $width } = props;

    return css`
      box-sizing: border-box;
      flex-direction: column;
      min-width: 0;
      padding: 8px;
      width: var(--${$width}Width);

      .cell {
        input {
          font-size: 1rem;
          padding-bottom: 20px;
        }
      }

      .error {
        color: ${theme.warningBase};
        color: var(--warning-base);
        flex-basis: 100%;
      }

      .MuiTextField-root {
        background: var(--white-full);
      }

      .MuiInputBase-root {
        border-radius: 3px 3px 0 0;
      }

      .MuiInput-underline,
      .MuiFilledInput-underline {
        &:hover::before {
          border-bottom: 2px solid var(--primary-light) !important;
        }
        &::before {
          border-bottom: 2px solid var(--default-base);
        }

        &::after {
          border-color: var(--primary-base);
        }

        &:hover {
          border-color: var(--primary-light);
        }

        &.Mui-error:after {
          border-bottom-color: ${theme.warningBase};
          border-bottom-color: var(--warning-base);
        }
      }

      .MuiOutlinedInput-root.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          border-color: var(--primary-base);
        }
      }

      input {
        background-image: none;
        border-radius: 3px 3px 0 0;
        color: var(--full-black);
        display: block;
        line-height: 16px;
        padding-left: 10px;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        width: 100%;

        &::placeholder {
          color: var(--default-light);
        }

        &:focus {
          border-color: var(--primary-base);
          box-shadow: inset 0 1px 1px var(--default-light),
            0 0 8px var(--secondary-light);
          outline: 0;
        }

        &::before {
          border-bottom: 2px solid var(--default-base);
        }

        &.has-error {
          border-color: ${theme.warningBase};
          border-color: var(--warning-base);
          box-shadow: inset 0 1px 1px var(--default-base);

          &:focus {
            border-color: ${theme.warningBase};
            border-color: var(--warning-base);
            box-shadow: inset 0 1px 1px var(--default-light),
              0 0 6px var(--warning-light);
          }
        }
      }
    `;
  }}
`;
